export default __webpack_public_path__ + "static/media/experience.afebcf32.svg";